"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=e(require("styled-components")).default.li`
  display: grid;
  grid-row-gap: 15px;

  @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
    opacity: ${({isPaginated:e,isSelected:i})=>e&&!i?0:1};
    z-index: ${({isPaginated:e,isSelected:i})=>e&&!i?-1:"auto"};
    transition: opacity 0.2s ease-in-out;
  }

  > header,
  .option > header {
    display: grid;
    grid-row-gap: 3px;

    > * {
      margin: 0;
    }

    @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
      display: ${({isPaginated:e})=>e?"none":"visible"};
    }
  }

  > ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-row-gap: 11px;
    height: max-content;
  }
`;module.exports=i;
//# sourceMappingURL=styles.js.map
